import {
  FETCH_ALL_BOOKING,
  FETCH_PROCESS_BOOKING,
  FETCH_SEND_BOOKING,
  FETCH_DONE_BOOKING,
  FETCH_BY_BOOKING,
  FETCH_BY_TRACKING,
  FETCH_BY_TRACKING_MOBILE,
  FETCH_BY_TRACKING_CUSTOMER,
  STATE_NEAREST_DRIVERS,
  FETCH_BY_TRACKING_SELF,
  FETCH_BY_TRACKING_ANY,
  STATE_ORDER_DRIVER_PICKUP,
  STATE_COORDINATE_CUSTOMER,
  CREATE_TRX_RIDE,
  UPDATE_TRX_RIDE,
  STATE_COORDINATE_DRIVER,
  FETCH_BY_TRX,
} from "../../Constants/actionTypes";

interface PaginatedData {
  data: any[];
  currentPage: number;
  numberOfPages: number;
}

export interface BookingState {
  dataBookingReducerAll: PaginatedData;
  dataBookingReducerProcess: PaginatedData;
  dataBookingReducerSend: PaginatedData;
  dataBookingReducerDone: PaginatedData;
  dataBookingReducer: { data: any[] };
  dataTrxDetail: Record<string, any>;
  dataTrackingReducer: Record<string, any>;
  dataTrackingReducerSelf?: Record<string, any>;
  dataTrackingMobileReducer: Record<string, any>;
  dataTrackingAnyReducer: Record<string, any>;
  dataTrackingCustomerReducer: Record<string, any>;
  dataTrxRide: Record<string, any>;
  dataTrxRideUpdate: Record<string, any>;
  stateNearestDrivers: Record<string, any>;
  stateOrderDriverPickup: Record<string, any>;
  dataStateCoordinateCustomer: Record<string, any>;
  dataStateCoordinateDriver: Record<string, any>;
}

const initialState: BookingState = {
  dataBookingReducerAll: { data: [], currentPage: 1, numberOfPages: 1 },
  dataBookingReducerProcess: { data: [], currentPage: 1, numberOfPages: 1 },
  dataBookingReducerSend: { data: [], currentPage: 1, numberOfPages: 1 },
  dataBookingReducerDone: { data: [], currentPage: 1, numberOfPages: 1 },
  dataBookingReducer: { data: [] },
  dataTrxDetail: {},
  dataTrackingReducer: {},
  dataTrackingMobileReducer: {},
  dataTrackingAnyReducer: {},
  dataTrackingCustomerReducer: {},
  dataTrxRide: {},
  dataTrxRideUpdate: {},
  stateNearestDrivers: {},
  stateOrderDriverPickup: {},
  dataStateCoordinateCustomer: {},
  dataStateCoordinateDriver: {},
};

const bookingReducer = (state = initialState, action: any): BookingState => {
  switch (action.type) {
    case FETCH_ALL_BOOKING:
      return {
        ...state,
        dataBookingReducerAll: {
          data: action.payload.data,
          currentPage: action.payload.currentPage,
          numberOfPages: action.payload.numberOfPages,
        },
      };
    case FETCH_PROCESS_BOOKING:
      return {
        ...state,
        dataBookingReducerProcess: {
          data: action.payload.data,
          currentPage: action.payload.currentPage,
          numberOfPages: action.payload.numberOfPages,
        },
      };
    case FETCH_SEND_BOOKING:
      return {
        ...state,
        dataBookingReducerSend: {
          data: action.payload.data,
          currentPage: action.payload.currentPage,
          numberOfPages: action.payload.numberOfPages,
        },
      };
    case FETCH_DONE_BOOKING:
      return {
        ...state,
        dataBookingReducerDone: {
          data: action.payload.data,
          currentPage: action.payload.currentPage,
          numberOfPages: action.payload.numberOfPages,
        },
      };
    case FETCH_BY_BOOKING:
      return { ...state, dataBookingReducer: { data: action.payload.data } };
      case FETCH_BY_TRACKING:
        return { ...state, dataTrackingReducer: action.payload };
        case FETCH_BY_TRX:
          return { ...state, dataTrxDetail: action.payload };
    case FETCH_BY_TRACKING_SELF:
      return { ...state, dataTrackingReducerSelf: action.payload };
    case FETCH_BY_TRACKING_MOBILE:
      return { ...state, dataTrackingMobileReducer: action.payload };
    case FETCH_BY_TRACKING_ANY:
      return { ...state, dataTrackingAnyReducer: action.payload };
    case FETCH_BY_TRACKING_CUSTOMER:
      return { ...state, dataTrackingCustomerReducer: action.payload };
    case CREATE_TRX_RIDE:
      return { ...state, dataTrxRide: action.payload };
    case UPDATE_TRX_RIDE:
      return { ...state, dataTrxRideUpdate: action.payload };
    case STATE_NEAREST_DRIVERS:
      return { ...state, stateNearestDrivers: action.payload };
    case STATE_ORDER_DRIVER_PICKUP:
      return { ...state, stateOrderDriverPickup: action.payload };
    case STATE_COORDINATE_CUSTOMER:
      return { ...state, dataStateCoordinateCustomer: action.payload };
    case STATE_COORDINATE_DRIVER:
      return { ...state, dataStateCoordinateDriver: action.payload };
    default:
      return state;
  }
};

export default bookingReducer;
